<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="3">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <drop-autoComplete label="账号" account v-model="accountId"></drop-autoComplete>
        <drop-autoComplete label="游戏" game v-model="gameId"></drop-autoComplete>
        <ElFormItem label="创建人">
          <auto-complete :data="agentData" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
        </ElFormItem>
        <ElFormItem>
          <DateRangePicker v-model="datetime" :clearable="false" style="width: 220px"></DateRangePicker>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button type="primary" @click="search">查询</el-button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import moment from 'moment'
import { setLocal, getLocal } from '@/common/js/api'
import { getSysMember } from '@/api/common.model'
import DropAutoComplete from '@/components/dropdown/eldropdown'
import AutoComplete from '@/components/autocomplete/autocomplete'
import { isArray } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker'

export default {
  name: 'smartptomFilter',
  components: { DropAutoComplete, AutoComplete, DateRangePicker },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    buildParams() {
      const [beginTime, endTime] = this.datetime || []
      const params = {
        adAccountId: this.accountId === -1 ? undefined : this.accountId,
        gameId: this.gameId === -1 ? undefined : this.gameId,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : this.keyword,
        beginTime,
        endTime
      }

      return params
    },
    sendEvent() {
      const params = this.buildParams()
      this.$emit('on-change', params)
    },
    search() {
      const params = this.buildParams()
      this.$emit('on-search', params)
    },
    proloadData() {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal('list-smartptom')
      getSysMember()
        .then((data) => {
          if (isArray(data)) {
            this.agentData = data.map((ret) => {
              // ret.id = ret.opId
              return ret
            })
            if (storage && isArray(storage[account])) this.agentId = Number(storage[account])
            else this.agentId = Number(account) || ''
          }
          // 初始化
          this.sendEvent()
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    handleAgent(meta) {
      this.agentId = meta.id
      if (meta && meta.id) this.setOperatorStorage('list-smartptom', meta.id)
      else this.setOperatorStorage('list-smartptom', -1)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    }
  },
  watch: {
    accountId(nVal) {
      this.sendEvent()
    },
    gameId(nVal) {
      this.sendEvent()
    },
    agentId(nVal) {
      this.sendEvent()
    }
  },
  data() {
    const now = moment().format('YYYY-MM-DD')
    return {
      keyword: '',
      accountId: -1,
      gameId: -1, // 游戏id
      agentId: '',
      agentData: [],
      datetime: [now, now]
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
